angular.module('dpw.components')
    /**
     * @ngdoc directive
     * @name dpwYoutube
     * @restrict EA
     * @param {String} url
     * @param {String} width
     * @param {String} height
     * @param {String} autoplay
     * @description
     * Generate Youtube Embedded iframe.
     * @example
     * <dpw-youtube youtube-url="" youtube-width="400" youtube-height="300"
     *              youtube-autoplay="true"></dpw-youtube>
     */
    .directive('dpwYoutube', [function () {
        return {
            restrict: 'EA',
            scope: true,
            templateUrl: 'dpw-youtube.html',
            bindToController: true,
            controllerAs: 'youtubeCtrl',
            controller: ['$scope', '$attrs', '$timeout', function ($scope, $attrs, $timeout) {
                var self = this;
                var settings = $scope.youtube || {};

                settings.width = $attrs.youtubeWidth || settings.width;
                settings.height = $attrs.youtubeHeight || settings.height;
                settings.autoplay = $attrs.youtubeAutoplay || settings.autoplay;

                $timeout(function() {
                    settings.url = $attrs.youtubeUrl || settings.url;
                    _.assign(self, settings);
                    self.url = self.url.replace(/watch\?v=/i, 'embed/');
                    self.url = self.url.replace(/youtu\.be/i, 'www.youtube.com/embed');

                    if (self.autoplay) {
                        self.url += '?autoplay=1&rel=0';
                    } else {
                        self.url += '?rel=0';
                    }
                });
            }]
        };
    }]);
